import { ExpenseCashbackLock } from "./ExpenseCashbackLock";
import { SettlementLock } from "./SettlementLock";
import { LockedActions, LockedActionsParams } from "./types";

// A trade owns a settled transfer and an expense its cashback income, so those rows show the lock in place of any actions.
export const lockedActions = ({
  settlement,
  cashbackExpenseId,
  actions,
  placeholder = null,
  onOpenExpense,
}: LockedActionsParams): LockedActions => {
  if (settlement) {
    return {
      lock: <SettlementLock settlement={settlement} />,
      actions: placeholder,
    };
  }
  if (cashbackExpenseId != null) {
    return {
      lock: <ExpenseCashbackLock onOpen={onOpenExpense} />,
      actions: placeholder,
    };
  }
  return { lock: null, actions };
};
